import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import Media from 'react-media';

class Intro extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      contentHeight: 0,
      imageHeight: 0,
    };
  }

  componentDidMount() {
    const contentHeight = this.divContent.clientHeight;
    const imageHeight = this.divImage.clientHeight;
    this.setState({ contentHeight, imageHeight });
  }

  render() {
    const { title, contentHTML, image } = this.props;
    const { contentHeight, imageHeight } = this.state;

    let centerStyle;
    if (contentHeight) {
      centerStyle =
        contentHeight <= imageHeight
          ? {
              position: 'absolute',
              top: '50%',
              transform: 'translateY(-50%)',
            }
          : {};
    }

    const contentStyle = {
      marginBottom: 30,
      fontFamily: 'Roboto',
      fontSize: 18,
      textAlign: 'justify',
      color: '#787878',
      ...centerStyle, // that merge the centerStyle's properties to contentStyle
    };

    return (
      <div style={{ paddingBottom: 30 }} className="container">
        <center>
          <h3 style={{ fontWeight: 'bold', marginBottom: 20 }}>{title}</h3>
        </center>
        <div className="row">
          <div className="col-md-6">
            <div className="container">
              <Media query={{ minWidth: 992 }}>
                {matches =>
                  matches ? (
                    <div
                      ref={divContent => (this.divContent = divContent)}
                      style={contentStyle}
                      dangerouslySetInnerHTML={{ __html: contentHTML }}
                    />
                  ) : (
                    <div
                      ref={divContent => (this.divContent = divContent)}
                      style={contentStyle}
                      dangerouslySetInnerHTML={{ __html: contentHTML }}
                    />
                  )
                }
              </Media>
            </div>
          </div>
          <div className="col-md-6">
            <div
              className="container"
              ref={divImage => (this.divImage = divImage)}
            >
              <Img alt={image.title} sizes={image.sizes} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Intro.propTypes = {
  title: PropTypes.string.isRequired,
  contentHTML: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
};

export default Intro;



// WEBPACK FOOTER //
// ./src/components/Main/brand/Intro.js